import ContainerHeader from 'components/ContainerHeader'
import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import './index.css'
import {
    DIFF_READING_DEFAULT,
    INITIAL_STATE,
    parseDifferenceReading,
    parseResponseConsolidado,
    parseNotasCredito
} from './Conciliacion.utils'
import FormularioConciliadorPDV from './components/FormularioConciliadorPDV'
import NovedadesConciliacion from './components/NovedadesConciliacion'
import AcordionDetail from './components/AcordionDetail'
import {
    crearCierreDia,
    getDiaConsolidado,
    getNovedades,
    obtenerDiasConsolidado,
    obtenerDiferenciasLecturaService
} from './services/conciliacionPDV.services'
import { formatearFecha } from 'util/formatDate'
import { IStateConsolidado } from './utils/interfaces'
import { objetoVacio } from 'util/utils'
import Mjs from 'components/Mjs/Mjs'
import { Spin, notification, Button, Popconfirm, Tabs } from 'antd'
import { sessionCaducada, sonMismaFecha } from 'util/funciones'
import ModuleAllowed from 'components/ModuleAllowed/ModuleAllowed'
import DiferencesReading from './components/DiferencesReading'

const ConciliacionPDV = ({ match }: any) => {
    const [form, setForm] = useState(INITIAL_STATE)
    const [consolidadoData, setConsolidadoData] = useState<IStateConsolidado>({} as IStateConsolidado)
    const [novedadesList, setNovedadesList] = useState([])
    const [loaders, setloaders] = useState({
        loadingNovedades: false,
        loadingConsolidado: false,
        loadingDiferenciasLectura: false,
        loadingConciliation: false
    })

    const [error, setError] = useState({
        errorNovedades: true,
        errorConsolidado: true
    })

    const [activeTab, setActiveTab] = useState<'compras' | 'ventas'>('compras')

    const handlerForm = (name: string, value: any) => {
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const handlerError = (name: string, value: boolean) => {
        setError(prev => ({ ...prev, [name]: value }))
    }

    const handlerLoaders = (name: string, value: boolean) => {
        setloaders(prev => ({ ...prev, [name]: value }))
    }

    const getData = async () => {
        if (form.estacion) {
            handlerLoaders('loadingConsolidado', true)
            handlerLoaders('loadingNovedades', true)
            const queryParams = { empresaId: form.estacion, startDate: formatearFecha(form.fecha, 'YYYY-MM-DD') }
            const queryParamsConsolidatedDay = {
                empresaId: form.estacion,
                fechaCierre: formatearFecha(form.fecha, 'YYYY-MM-DD')
            }
            try {
                const responseConsolidatedDay = await obtenerDiasConsolidado(queryParamsConsolidatedDay)
                console.log('ress::', responseConsolidatedDay)
                const diaConciliado = (responseConsolidatedDay?.data?.length ?? 0) > 0
                handlerForm('deshabilitarConciliarDia', diaConciliado)
                handlerForm('deshabilitarConciliarVentas', diaConciliado)
            } catch (error) {
                console.log(error.response)
                notification.error({ message: 'Ocurrió un al obtener estado del día' })
            }
            try {
                const response = await getNovedades(queryParams)
                setNovedadesList(response.data.result)
                handlerError('errorNovedades', false)
            } catch (error) {
                console.log(error.response)
                notification.error({ message: 'Ocurrió un al obtener las novedades del día' })
                handlerError('errorNovedades', true)
            } finally {
                handlerLoaders('loadingNovedades', false)
            }
            try {
                const responseConsolidado = await getDiaConsolidado(queryParams)
                const { data } = await obtenerDiferenciasLecturaService(queryParams)
                console.log('CLG: ', data)
                setConsolidadoData({
                    combustible: parseResponseConsolidado(responseConsolidado.data.result.fuel),
                    kiosco: parseResponseConsolidado(responseConsolidado.data.result.kiosco),
                    canastilla: parseResponseConsolidado(responseConsolidado.data.result.canastilla),
                    notasCredito: parseNotasCredito(responseConsolidado.data.result.notasCredito || []),
                    diferenciaLectura: {
                        detalle: parseDifferenceReading(data?.result?.detallado || {}),
                        totales: objetoVacio(data?.result?.total || {}) ? DIFF_READING_DEFAULT : data.result.total
                    }
                })
                handlerError('errorConsolidado', false)
            } catch (error) {
                console.log(error)
                if (error?.response?.status == 401) {
                    sessionCaducada()
                } else {
                    notification.error({ message: 'Ocurrió un error al obtener los datos' })
                }
                handlerError('errorConsolidado', true)
            } finally {
                handlerLoaders('loadingConsolidado', false)
            }
        } else {
            notification.info({ message: 'Por favor, seleccione una estación' })
        }
    }

    const deshabilitarConciliacion = () => 
        novedadesList.length != 0 ||
        sonMismaFecha(form.fecha, new Date()) ||
        error.errorConsolidado ||
        error.errorNovedades ||
        form.deshabilitarConciliarDia

    const deshabilitarConciliacionVentas = () => {
        const baseDisabled =
            novedadesList.length != 0 ||
            sonMismaFecha(form.fecha, new Date()) ||
            error.errorConsolidado ||
            error.errorNovedades
        const comprasConciliadas = !!form.deshabilitarConciliarDia
        // Además, si ya se concilió ventas, debe estar deshabilitado
        const ventasConciliadas = !!form.deshabilitarConciliarVentas
        return baseDisabled || !comprasConciliadas || loaders.loadingConciliation || ventasConciliadas
    }

    const onIniciarCierreDiaCompras = async () => { 
         try {
            const bodyConsolidatedDay: any = {
                empresaId: form.estacion,
                fechaCierre: formatearFecha(form.fecha, 'YYYY-MM-DD')
            }
            handlerLoaders('loadingConciliation', true)
            handlerForm('deshabilitarConciliarDia', true)
            notification.success({
                message: '¡Muy bien!',
                description: 'Proceso de conciliación iniciado correctamente'
            })
        } catch (error) {
            console.log(error)
            notification.error({
                message: 'Algo salió mal',
                description: 'No se pudó iniciar el proceso de conciliación, por favor intente mas tarde.'
            })
        } finally {
            handlerLoaders('loadingConciliation', false)
        }
    }

    const onIniciarCierreDia = async () => {
        try {
            const bodyConsolidatedDay: any = {
                empresaId: form.estacion,
                fechaCierre: formatearFecha(form.fecha, 'YYYY-MM-DD')
            }
            handlerLoaders('loadingConciliation', true)
            await crearCierreDia(bodyConsolidatedDay)
            // marcar que las ventas quedaron conciliadas para deshabilitar el botón
            handlerForm('deshabilitarConciliarVentas', true)
            // también mantener la marca general de conciliación del día
            handlerForm('deshabilitarConciliarDia', true)
            notification.success({
                message: '¡Muy bien!',
                description: 'Proceso de conciliación iniciado correctamente'
            })

        } catch (error) {
            console.log(error)
            notification.error({
                message: 'Algo salió mal',
                description: 'No se pudó iniciar el proceso de conciliación, por favor intente mas tarde.'
            })
        } finally {
            handlerLoaders('loadingConciliation', false)
        }
    }

    useEffect(() => {
        setNovedadesList([])
        setConsolidadoData({} as IStateConsolidado)
    }, [form.estacion, form.fecha])

    return (
        <div style={{ padding: '20px' }}>
            <ContainerHeader title={'CONCILIADOR EDS'} match={match} />
            <ModuleAllowed nameModule="CONCILIACIÓN PDV">
                <FormularioConciliadorPDV
                    loading={loaders.loadingConsolidado}
                    onSumbit={() => getData()}
                    form={form}
                    handlerForm={handlerForm}
                    setForm={setForm}
                    key={'form'}
                />
                {objetoVacio(consolidadoData) ? (
                    <Spin spinning={loaders.loadingConsolidado}>
                        {' '}
                        <Mjs mensaje={'Consulte la información del día'} />
                    </Spin>
                ) : (
                    <>
                        <Tabs
                            activeKey={activeTab}
                            onChange={key => setActiveTab(key as 'compras' | 'ventas')}
                            centered
                            size="large"
                            style={{ marginTop: '20px' }}
                            items={[
                                {
                                    key: 'compras',
                                    label: 'Compras e inventarios',
                                    children: (
                                        <>
                                            <Grid container style={{ marginTop: '10px' }} spacing={2}>
                                                <Grid
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                    item
                                                    xs={12}
                                                    className="fix-grid"
                                                    md={6}
                                                >
                                                    <NovedadesConciliacion
                                                        loading={loaders.loadingNovedades}
                                                        novedadesList={novedadesList}
                                                    />
                                                </Grid>
                                                <Grid
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                    item
                                                    xs={12}
                                                    md={6}
                                                >
                                                    <div className={'fix-grid-botones'}>
                                                        <Popconfirm
                                                            disabled={
                                                                novedadesList.length != 0 ||
                                                                sonMismaFecha(form.fecha, new Date()) ||
                                                                error.errorConsolidado ||
                                                                error.errorNovedades
                                                            }
                                                            title="¿Está seguro de conciliar el día compras e inventarios?"
                                                            description="NOTA: Una vez seleccione aceptar esta acción no podrá revertir"
                                                            onConfirm={onIniciarCierreDiaCompras}
                                                            onOpenChange={() => console.log('open change')}
                                                        >
                                                            <Button
                                                                loading={loaders.loadingConciliation}
                                                                style={{
                                                                    background: deshabilitarConciliacion()
                                                                        ? 'lightgray'
                                                                        : '#0FAB0B',
                                                                    color: '#FFFFFF',
                                                                    width: '100%',
                                                                    maxWidth: '250px',
                                                                    height: 'auto',
                                                                    minHeight: '40px',
                                                                    padding: '8px 16px',
                                                                    whiteSpace: 'normal',
                                                                    lineHeight: '1.2'
                                                                }}
                                                                disabled={
                                                                    deshabilitarConciliacion() ||
                                                                    loaders.loadingConciliation
                                                                }
                                                            >
                                                                Conciliar día compras e inventarios
                                                            </Button>
                                                        </Popconfirm>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid container style={{ marginTop: '10px' }}>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail datos={consolidadoData.kiosco} negocio="COMPRAS" />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail
                                                        datos={consolidadoData.canastilla}
                                                        negocio="INVENTARIOS"
                                                    />
                                                </Grid>
                                           
                                            </Grid>
                                        </>
                                    )
                                },
                                {
                                    key: 'ventas',
                                    label: 'Ventas',
                                    children: (
                                        <>
                                            <Grid container style={{ marginTop: '10px' }} spacing={2}>
                                                <Grid
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                    item
                                                    xs={12}
                                                    className="fix-grid"
                                                    md={6}
                                                >
                                                    <NovedadesConciliacion
                                                        loading={loaders.loadingNovedades}
                                                        novedadesList={novedadesList}
                                                    />
                                                </Grid>
                                                <Grid
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                    item
                                                    xs={12}
                                                    md={6}
                                                >
                                                    <div className={'fix-grid-botones'}>
                                                        <Popconfirm
                                                            disabled={deshabilitarConciliacionVentas()}
                                                            title="¿Está seguro de conciliar el día ventas?"
                                                            description="NOTA: Una vez seleccione aceptar esta acción no podrá revertir"
                                                            onConfirm={onIniciarCierreDia}
                                                            onOpenChange={() => console.log('open change')}
                                                        >
                                                            <Button
                                                                loading={loaders.loadingConciliation}
                                                                style={{
                                                                    background: deshabilitarConciliacionVentas()
                                                                        ? 'lightgray'
                                                                        : '#0FAB0B',
                                                                    color: '#FFFFFF',
                                                                    width: '100%',
                                                                    maxWidth: '250px',
                                                                    height: 'auto',
                                                                    minHeight: '40px',
                                                                    padding: '8px 16px',
                                                                    whiteSpace: 'normal',
                                                                    lineHeight: '1.2'
                                                                }}
                                                                disabled={deshabilitarConciliacionVentas()}
                                                            >
                                                                Conciliar día ventas
                                                            </Button>
                                                        </Popconfirm>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid container style={{ marginTop: '10px' }}>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail datos={consolidadoData.combustible} />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail datos={consolidadoData.kiosco} negocio="KIOSCO" />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail
                                                        datos={consolidadoData.canastilla}
                                                        negocio="CANASTILLA"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail
                                                        datos={consolidadoData.canastilla}
                                                        negocio="GNV"
                                                    />
                                                </Grid>
                                                  <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail
                                                        datos={consolidadoData.canastilla}
                                                        negocio="GPL"
                                                 /> 
                                                </Grid>
                                                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                        <DiferencesReading data={consolidadoData.diferenciaLectura} />
                                                    </Grid>
                                                </Grid>
                                                
                                                <Grid item xs={12} style={{ marginTop: '10px' }}>
                                                    <AcordionDetail
                                                        datos={consolidadoData.notasCredito}
                                                        negocio="NOTAS CREDITO"
                                                 /> 
                                                </Grid>
                                            
                                                
                                        </>
                                    )
                                }
                            ]}
                        />
                    </>
                )}
            </ModuleAllowed>
        </div>
    )
}

export default ConciliacionPDV
